module.exports = __webpack_public_path__ + "static/611-70b2adbe0c3e5e60218bd55545e8f508.png";